import React, {useEffect} from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import EmptyState from '../EmptyState';

import styles from './styles.module.scss';

const emptyStatePropsMap = {
  content: {
    type: 'content',
    title: 'Training not Found',
    description: 'No training matching the keyword',
  },
  user: {
    type: 'user',
    title: 'User not Found',
    description: 'No users matching the keyword',
  },
  'search-user': {
    type: 'search',
    title: 'Search for user',
    description: 'Start typing some letters and we’ll help you find it',
  },
  'search-content': {
    type: 'search',
    title: 'Search for training',
    description: 'Start typing some letters and we’ll help you find it',
  },
};

function SearchContainer({
  data,
  rowRender,
  type,
  searchField,
  keyword,
  onCountChange,
}) {
  const searchRegExp = new RegExp(`.*${keyword}.*`, 'ig');

  // eslint-disable-next-line no-param-reassign
  type = !keyword ? `search-${type}` : type;
  const emptyStateProps = emptyStatePropsMap[type];

  const filteredData = data.filter((row) =>
    row[searchField].match(searchRegExp)
  );

  useEffect(() => {
    onCountChange?.(keyword ? filteredData.length : 0);
  }, [filteredData, keyword, onCountChange]);

  return (
    <div styleName='search-container'>
      {!!keyword && filteredData.map((row, index) => rowRender(row, index))}
      {(!filteredData.length || !keyword) && (
        <EmptyState {...emptyStateProps} />
      )}
    </div>
  );
}

SearchContainer.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  rowRender: PropTypes.func.isRequired,
  keyword: PropTypes.string.isRequired,
  searchField: PropTypes.string.isRequired,
  onCountChange: PropTypes.func,
};

export default CSSModules(SearchContainer, styles, {allowMultiple: true});
